import * as React from "react";
import { gql, useQuery } from "@apollo/client";
import {
  Customer,
  ViewCustomerWithSpendQuery,
  ViewCustomerWithSpendQueryVariables
} from "../../../schemaTypes";

export const viewCustomerWithSpendQuery = gql`
  query ViewCustomerWithSpend($id: String!) {
    viewCustomerWithSpend(id: $id) {
      customer {
        id
        firstname
        lastname
        username
        community {
          id
          name
          alias
        }
      }
      userId
      totalSpent
    }
  }
`;

export interface WithViewCustomerWithSpend {
  customer: Customer | null;
  userId: string | null;
  totalSpent: number;
  loading: boolean;
}

interface Props {
  customerId: string;
  children: (data: WithViewCustomerWithSpend) => React.ReactElement | null;
}

export const ViewCustomerWithSpend: React.FC<Props> = ({ customerId, children }) => {
  const { data, loading } = useQuery<
    ViewCustomerWithSpendQuery, 
    ViewCustomerWithSpendQueryVariables
  >(
    viewCustomerWithSpendQuery, {
      variables: { id: customerId }
    }
  );

  let customer: Customer | null = null;
  let userId: string | null = null;
  let totalSpent = 0;

  if (data && data.viewCustomerWithSpend) {
    customer = data.viewCustomerWithSpend.customer as Customer;
    userId = data.viewCustomerWithSpend.userId ?? null;
    totalSpent = data.viewCustomerWithSpend.totalSpent ?? 0;
  }

  return children({
    customer,
    userId,
    totalSpent,
    loading
  });
};